export class AuthOffice{
    officeId?: number;
    officeCode?: string;
    officeName?: string;
}

export class AuthMill{
    millId?: number;
    name?: string;
    shortName?: string;
    city?: string;
    country?: string;
}

export class AuthorizationsAllowedUnitTypes{
    key?: string[];
}

export class AuthorizationInfo{
    offices?: AuthOffice[];
    mills?: AuthMill[];
    authorizationsAllowedUnitTypes?: AuthorizationsAllowedUnitTypes;
}